const styles = (theme) => ({
    container: {
        listStyle: 'none',
        margin: '.35em 0',
        padding: '.35em',
        fontSize: '.85em',
        cursor: 'pointer',
        fontWeight: 500,
        color: theme.palette.primary.main,
        '&:hover': {
            color: '#0066CC',
        },
    },
});

export default styles;
